import React from "react";
import styles from "./FranchiseTableHeader.module.css";

export const FranchiseTableHeader: React.FC = () => {
    return <div className={styles.wrapper}>
        <span className={styles.nameCell}>Name</span>
        <span className={styles.hashCell}>Hash</span>
        <span className={styles.urlPatternCell}>URL Pattern</span>
        <span className={styles.actionsCell}>Actions</span>
    </div>;
};
